var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOutGlass = function SvgZoomOutGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.797 6.39A6.24 6.24 0 0 1 7.03.157a6.24 6.24 0 0 1 6.235 6.235 6.16 6.16 0 0 1-1.282 3.773l3.82 3.844c.165.164.258.39.258.64 0 .524-.367.922-.898.922a.92.92 0 0 1-.664-.265l-3.844-3.852a6.18 6.18 0 0 1-3.625 1.172A6.24 6.24 0 0 1 .797 6.391m1.336 0a4.9 4.9 0 0 0 4.898 4.9 4.9 4.9 0 0 0 4.899-4.9A4.9 4.9 0 0 0 7.03 1.493a4.9 4.9 0 0 0-4.898 4.899m2.89.57a.58.58 0 0 1-.578-.57c0-.312.266-.577.578-.577H9.04a.574.574 0 0 1 0 1.148z"
  })));
};
export default SvgZoomOutGlass;